import type { ExpectedUserBenefitType, ExpectedUserBenefit } from '@openclassrooms/sdk-web';
import { getMostRelevantBenefit } from '@openclassrooms/common-app/currentUser/services';

export default function useUserHasExpectedBenefits(
  benefitsToFind: ExpectedUserBenefitType | ExpectedUserBenefitType[],
  expectedBenefits?: ExpectedUserBenefit[]
) {
  if (!expectedBenefits) {
    return false;
  }

  const a = getMostRelevantBenefit(expectedBenefits);
  const benefitList = Array.isArray(benefitsToFind) ? benefitsToFind : [benefitsToFind];

  return a ? benefitList.includes(a) : false;
}
